import {OrganizationDataModel} from '../organization/organization-data.model';
import {FeeScheduleDoctorDataModel} from './fee-schedule-doctor.model';
import {XauditModel} from '../xaudit.model';
import {FeeScheduleItemDataModel} from './fee-schedule-item-data.model';

export class FeeScheduleDataModel extends XauditModel {
  FeeScheduleID: string;
  TDOCID: number;
  FeeScheduleName: string;
  OrganizationID: string;
  enumFeeScheduleTypeId: string;
  PatientInsuranceID: string;



  dataFeeScheduleDoctors: FeeScheduleDoctorDataModel[];
  dataFeeScheduleItems: FeeScheduleItemDataModel[];
  dataOrganizationss: OrganizationDataModel[];
  dataOrganizations: OrganizationDataModel;

  Selected: boolean;
  DoctorId: string;
}
